/**
 * @file Manages the functionalities of User Access Control based on Groups->Roles->Counties.
 * @author Sri Pooja <sri.pooja@delasoft.com>
 */
import { Chip, IconButton } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { createRequest, requestApi } from '../../helpers/rest';
import CheckboxesTags from '../checkautocomplete';
import { useSelector } from 'react-redux';

const options = {
    name: 'RoutingAccessControl',
    "title": 'Routing Access Control',
    read: [
        {// this url will change based on recordsref
            url: getEnvVariable('Admin') + `/api/Users/SiteAccessControl/{SITE_ID}`,
            type: 'get',
            routeProps: [{
                name: "SITE_ID",
                key: "SITE_ID",
            }],
        },
    ]
}


export default function RoutingAccessControl({ ...props }) {
    const routeParams = useParams()
    const params = (props.dataItem && props.dataItem.userId) ? { Id: props.dataItem.userId } : routeParams;
    const [data, setData] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [user, setuser] = useState(null)
    const [groupIndeterminate, setGroupIndeterminate] = useState(false)
    const [result, setResult] = useState(props.item || { isCalcualtedQuery: 'Y' })
    const [originalData, setOriginalData] = useState(null)
    //const { components, extraProps, match, dataItem } = props
    //  const { isprofile } = components;
    const parentRecordVals = useSelector(state => state.sidebar && state.sidebar.modules);
    const { read } = options ? options : {}
    var get = read.filter(e => e.type === 'get')
    var customProps = get.filter(e => e.customProps ? e : null);



    /**
     * Initial Request to get the data
     */
    useEffect(() => {
        if (options && options.read) {
            let read = options.read.filter(each => { if (each.type === 'get') return each })
            read = read.filter(each => each.customProps ? each.customProps : each.routeProps);
            Promise.all(read.map(each => requestApi(createRequest(each, {}, { ...params, ...parentRecordVals })))).then(resp => {
                const [accesscontrol] = resp //user
                setOriginalData(accesscontrol)
                setData(accesscontrol[0].items)
                //setuser(user)
            })
        }
    }, [])

    const handleSave = () => {
        let url = props.options.read.filter(each => { if (each.type === 'post') return each })
       // let url = options.read.filter(each => { if (each.type === 'post') return each })
        originalData[0].items = data;
        requestApi(createRequest(url[0], originalData,{ ...params, ...parentRecordVals } )).then(resp => {
            if (resp)
                setData(data);;
            // handleModuleSave(modresult);
        })

    }

    const handleSubItems = (items, check) => {
        return items.map(each => {
            if (each && each.items && each.items.length > 0) {
                each.checked = check;
                handleSubItems(each.items, check)
            }
            else each.checked = check;
            return each
        })
    }

    /**
   * on click on group , selecting all the sub roles and counties
   */
    const checkGroupSection = (evt, index) => {
        evt.stopPropagation()
        let each = data[index];
        if (each && each.items && each.items.length > 0) {
            each.checked = !each.checked
            each.items = handleSubItems(each.items, each.checked);
        }
        else {
            each.checked = !each.checked
        }
        data[index] = each;
        setData(data);
        setRefresh(!refresh)
    }

    const checkRoleSection = (evt, index, parent) => {
        evt.stopPropagation()
        let each = data[parent]['items'][index];
        if (each && each.items && each.items.length > 0) {
            each.checked = !each.checked
            each.items = handleSubItems(each.items, each.checked);
        }
        else {
            each.checked = !each.checked
        }
        data[parent]['items'][index] = each;
        if (data[parent]) {
            if (data[parent]['items'].every(item => item.checked === true))
                data[parent].checked = true
            else data[parent].checked = false
        }
        setData(data);
        setRefresh(!refresh)
    }

    const handleCountyChange = (evt, parent, index) => {
        const { name, value } = evt.target
        let each = data[parent]['items'][index];
        let tempval = value.split(',');
        if (each && each.items && each.items.length > 0)
            each.items.map(item => {
                if (tempval.includes(item.id.toString())) {
                    item.checked = true;
                }
                else item.checked = false
            })
        data[parent]['items'][index] = each;
        if (data[parent] && data[parent]['items'][index] && data[parent]['items'][index].items) {
            if (data[parent]['items'][index].items.every(item => item.checked === true)) {
                data[parent].checked = true
                data[parent]['items'][index].checked = true
            }
            else {
                data[parent].checked = false
                data[parent]['items'][index].checked = false
            }
        }
        setGroupIndeterminate({ [parent]: data[parent]['items'][index].items.some(item => item.checked === true) ? true : false })

        setData(data);
        setRefresh(!refresh)
    }

    const handleIndetermineGroupCheck = (group) => {
        let indeterminate = false
        if (group && group.items && group.items.length > 0) {
            indeterminate = group.items.some(each => {
                return each.checked === true
            })
            if (indeterminate === false) {
                indeterminate = group.items.some(each => {
                    if (each && each.items && each.items.length > 0) {
                        return each.items.some(eachItem => {
                            return eachItem.checked === true
                        })
                    }
                })
            }
            return indeterminate
        }
        else return false
    }




    return <div className='col-12 py-1'>
        <IconButton className='float-end ' size='small' color='primary' onClick={e => handleSave(result)}><SaveIcon /></IconButton>
        <div className='clearfix'></div>
        <div style={{
            height: '500px', overflowY: 'auto'
        }}>
            {data && data.length > 0 && (data || []).map((each, index) => {
                return <Accordion key={'parent-' + index}>
                    <AccordionSummary
                        style={{ maxHeight: '45px', minHeight: '45px' }}
                        expandIcon={<ExpandMoreIcon color='inherit' />}
                        aria-label="Expand"
                        aria-controls="additional-actions1-content"
                        id="additional-actions1-header"
                    >
                        {true ? (customProps.length <= 0 ? <FormControlLabel

                            aria-label="Acknowledge"
                            onFocus={(event) => event.stopPropagation()}
                            onClick={(event) => checkGroupSection(event, index)}
                            control={<Checkbox checked={each.checked || (each.items.every(item => item.checked === true) ? true : false)}
                                indeterminate={each.items.every(item => item.checked === true) ? false :
                                    handleIndetermineGroupCheck(each) ? true : groupIndeterminate[index]}
                            />}
                            label={<small className='fw-bold '>{each.text}</small>}
                        /> : <div className='fw-bold'>{each.text}</div>) : <div className='fw-bold'>{each.text}</div>}
                    </AccordionSummary>
                    <div className='col-12'>
                        <div className='row fw-bold' >
                            <div className=" col-3">Roles</div>
                            <div className="col-7" >User(s)</div>
                        </div>
                        {/* style={{ color: 'white', backgroundColor: 'rgb(4 133 185)', }} */}
                    </div>
                    {each.items && each.items.length > 0 && (each.items || []).map((subeach, subindex) => {
                        return <AccordionDetails key={'child-' + subindex}>
                            <div className='row col-12 py-2'>
                                {true ? <div className='col-3'><FormControlLabel
                                    aria-label="Acknowledge"
                                    onFocus={(event) => event.stopPropagation()}
                                    onClick={(event) => checkRoleSection(event, subindex, index)}
                                    control={<Checkbox checked={subeach.checked || subeach.items.every(item => item.checked === true)}
                                        style={{ color: 'white' }}
                                        indeterminate={subeach.items.every(item => item.checked === true) ? false :
                                            (subeach.items.some(item => item.checked === true) ? true : false)}
                                    />}
                                    label={subeach.text}
                                /></div> : <div className='col'>{subeach.text}</div>}
                                {true ? <div className='col-7' >
                                    <CheckboxesTags limitTags={2} value={(subeach.items.map(function (a) { if (a.checked === true) return a.id })).join(',') || ''}
                                        ismulti={true} items={subeach.items} handleFieldValue={(evt) => handleCountyChange(evt, index, subindex)} extraProps={{
                                            transformProps: {
                                                label: 'text',
                                                value: 'id'
                                            }
                                        }}
                                    />
                                </div> :
                                    <div className='col-7' >{subeach.items.map(a => { if (a.checked === true) return <Chip label={a.text} className='ml-1' variant="outlined" /> })}</div>}
                            </div>
                        </AccordionDetails>
                    })}
                </Accordion>
            })}
        </div>
    </div>
}